import { Button, Card, Col, Form } from "react-bootstrap";
import { ButtonRemover, ButtonTrash, JRow, JTable, JTBody, JTHead, JvCaption } from "../../../components/Components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownLong, faPlus } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { infTermDescarregInterface, SelectObjectRemoveInterface } from "../../../interfaces";
import { useEffect, useRef, useState } from "react";
import { formatMoeda, getUuidV4, goToFocus } from "../../../utils/utils";
import { addTerminalDescarrega, removeTerminalDescarrega, removeTerminalDescarregaTodos } from "../../../features/manifestoSlice";
import { useModalMessage } from "../../../components/ModalMessage/useModalMessage";
import { useQuestion } from "../../../components/ModalQuestion/useModalQuestion";

const LIMITE: number = 5;

const initialState: infTermDescarregInterface = {
    id: 0,
    ctermdescarreg: '',
    xtermdescarreg: '',
}

export default function TerminalDescarregamento() {
    const [selecionado, setSelecionado] = useState<number | string>('');
    const dispatch = useDispatch();
    const lista = useSelector((state: RootState) => state.manifesto.manifesto.modal_aquatico.infTermDescarreg);
    const [form, setForm] = useState<infTermDescarregInterface>(initialState);
    const codTerminal = useRef<HTMLInputElement>(null)
    const nomeTerminal = useRef<HTMLInputElement>(null)
    const { alertModal, ModalMessageEl } = useModalMessage();
    const { confirm, ConfirmModal } = useQuestion();
    const [saldo, setSaldo] = useState<number>(0);

    const validaPreenchimento = () => {
        if (form.ctermdescarreg.toString() === "") {
            alertModal('Informe o Código do terminal');
            goToFocus(codTerminal);
            return false;
        }

        if (form.xtermdescarreg.toString() === "") {
            alertModal('Informe o nome do terminal');
            goToFocus(nomeTerminal);
            return false;
        }

        if (lista.length >= LIMITE) {
            alertModal(`Limite de ${formatMoeda(LIMITE, 0)} terminais atingido.`);
            return false;
        }

        if (lista.find((item: infTermDescarregInterface) =>
            item.ctermdescarreg.trim() === form.ctermdescarreg.trim())) {
            alertModal('Código do terminal já adicionado.');
            return false;
        }

        return true;
    }

    const handleAdd = () => {
        if (validaPreenchimento()) {
            dispatch(addTerminalDescarrega({ ...form, id: getUuidV4() }))
            setForm(initialState);
            goToFocus(codTerminal);
        }
    }

    const handleRemover = async (value: SelectObjectRemoveInterface) => {
        setSelecionado(value.id)
        const confirmed = await confirm({
            message: <>Deseja realmente remover Cod. Terminal: <strong>{value.title}</strong> ?</>,
            title: "Confirmação"
        });
        if (confirmed) {
            dispatch(removeTerminalDescarrega(value.id));
        }
        setSelecionado('')
    }
    const handleRemoverTodos = async () => {
        if (lista.length > 0) {
            const confirmed = await confirm({
                message: <>Remover todos ?</>,
                title: "Confirmação"
            });

            if (confirmed) {
                dispatch(removeTerminalDescarregaTodos());
            }
        }
    }

    const handleChange = (e: any) => {
        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    useEffect(() => {
        setSaldo(lista.length);
    }, [lista])

    return (<>
        <Card className="card-primary card-outline">
            <Card.Header><FontAwesomeIcon icon={faDownLong} className="text-danger" /> Informações dos terminais de descarregamento <span
                className="text-primary fw-semibold">(Opcional)</span>
            </Card.Header>
            <Card.Body>
                <JRow className="mb-3">
                    <Col md={3}>
                        <Form.Group controlId="aquav-td-ctermcarreg">
                            <Form.Label>* Código</Form.Label>
                            <Form.Control type="text" name="ctermdescarreg"
                                title="Código identificador do terminal"

                                maxLength={8} value={form.ctermdescarreg}
                                ref={codTerminal}
                                onChange={handleChange} />
                        </Form.Group>
                    </Col>

                    <Col md>
                        <Form.Group controlId="aquav-td-xtermdescarreg">
                            <Form.Label>* Nome do Terminal</Form.Label>
                            <Form.Control type="text" name="xtermdescarreg"
                                title="Nome do terminal"

                                maxLength={60} value={form.xtermdescarreg}
                                ref={nomeTerminal}
                                onChange={handleChange} />
                        </Form.Group>
                    </Col>

                    <Col md={'auto'} className="d-flex  align-items-end">
                        <Button title="Adicionar" variant="primary" onClick={handleAdd}>
                            <FontAwesomeIcon icon={faPlus} />
                        </Button>
                    </Col>
                </JRow>

                <JTable>
                    <JvCaption>({saldo} de {LIMITE} no máximo)</JvCaption>
                    <JTHead >
                        <tr>
                            <th className="text-center" style={{ width: '4rem' }}>
                                <ButtonTrash onClick={() => handleRemoverTodos()} />
                            </th>
                            <th className="text-center" style={{ width: '11rem' }}>Cód. Terminal</th>
                            <th className="text-center" >Nome Terminal</th>
                        </tr>
                    </JTHead>

                    <JTBody>
                        {lista?.map((item: infTermDescarregInterface) => (
                            <tr key={item.id}
                                className={item.id.toString() === selecionado.toString() ? 'table-danger' : ''}>
                                <td className="text-center">
                                    <ButtonRemover onClick={() => handleRemover({ id: item.id, title: item.xtermdescarreg })} />
                                </td>
                                <td className="text-center">{item.ctermdescarreg}</td>
                                <td className="text-center">{item.xtermdescarreg}</td>
                            </tr>
                        ))}
                    </JTBody>
                </JTable>
            </Card.Body>
        </Card>
        {ModalMessageEl}
        {ConfirmModal}
    </>)
}